import { abTests, ExperimentName } from '@/experiments';
import { ExperimentVariant } from '@/experiments/types/ExperimentVariant';

export const getVariant = (
	experimentName: ExperimentName
): ExperimentVariant | undefined => {
	const experimentsCookie = abTests.getExperiments();

	return experimentsCookie?.[experimentName];
};

const createFeatureFlag = (experimentName: ExperimentName) => ({
	getVariant: () => getVariant(experimentName),
	shouldShowVariant: () => getVariant(experimentName) === 'B',
});

export const featureFlags = {
	dummyExperiment: createFeatureFlag('dummy123_dummy_experiment'), // example feature flag name - DO NOT REMOVE
	// add more here...
};
